import clsx from "clsx";
import Footer from "../components/ui/Footer";
import Header from "../components/ui/Header";

const BaseTemplate = ({ children, className }) => {
  return (
    <div className="h-full bg-gray-100 grid grid-rows-[auto_1fr_auto]">
      <Header />
      <main className={clsx("flex p-4 overflow-hidden", className)}>
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default BaseTemplate;
